import { lazy } from "react";

// route
export const reportRoute = { path: "/report", name: "menu.report", icon: "content_paste" };
export const rSellingInvoiceRoute = { path: `${reportRoute.path}/inv_out`, name: "Penjualan" };
export const rSellingInvoiceDetailRoute = { path: `${reportRoute.path}/inv_out_detail`, name: "Detail Penjualan" };
export const rPurchInvoiceRoute = { path: `${reportRoute.path}/purchaseInvoice`, name: "Pembelian" };
export const rDORoute = { path: `${reportRoute.path}/r-do`, name: "Delivery Order" };
export const rDODetailRoute = { path: `${reportRoute.path}/r-do_detail`, name: "Detail Delivery Order" };
export const rSORoute = { path: `${reportRoute.path}/r-so`, name: "Sales Order" };
export const rSODetailRoute = { path: `${reportRoute.path}/r-so_detail`, name: "Detail Sales Order" };
export const rReturnCustomerRoute = { path: `${reportRoute.path}/return_customer`, name: "common_report.return_cus." };
export const rReturnSupplierRoute = { path: `${reportRoute.path}/return_supplier`, name: "common_report.return_sup." };
export const rSalesCommissionRoute = { path: `${reportRoute.path}/sales_commission`, name: "common_report.sales_commission." };
export const rStockPriceRoute = { path: `${reportRoute.path}/stock_price`, name: "common_report.stock_price." };
export const rDeliveryRoute = { path: `${reportRoute.path}/delivery`, name: "common_report.delivery." };
export const rHPPRoute = { path: `${reportRoute.path}/hpp`, name: "common_report.hpp." };
export const rPaymentSalesRoute = { path: `${reportRoute.path}/rpayment_sales`, name: "common_report.payment_sales." };
export const rPaymentPurchRoute = { path: `${reportRoute.path}/rpayment_purch`, name: "common_report.payment_purch." };

export const rGroupRoute = { path: `${reportRoute.path}/group`, name: "common_report.group." };
export const rGroupViewRoute = { path: `${rGroupRoute.path}/view`, name: "common_report.group.", code: 'RG' };
export const rGroupViewItemStockRoute = { path: `${rGroupViewRoute.path}/item_stock`, name: "whs_itemstock.", code: 'RGIS' };
export const rGroupViewItemInRoute = { path: `${rGroupViewRoute.path}/item_in`, name: "whs_itemin.", code: 'RGII' };
export const rGroupViewItemOutRoute = { path: `${rGroupViewRoute.path}/item_out`, name: "whs_itemout.", code: 'RGIO' };

// component
const Report = lazy(() => import("../page/report/Report"));
const RSellingInvoice = lazy(() => import("../page/report/selling_invoice/ReportSellingInvoice"));
const RSellingInvoiceDetail = lazy(() => import("../page/report/selling_invoice/ReportSellingInvoiceDetail"));
const RPurchaseInvoice = lazy(() => import("../page/report/purchase_invoice/ReportPurchaseInvoice"));
const RDO = lazy(() => import("../page/report/do/ReportDO"));
const RDODetail = lazy(() => import("../page/report/do/ReportDODetail"));
const RSO = lazy(() => import("../page/report/so/ReportSO"));
const RSODetail = lazy(() => import("../page/report/so/ReportSODetail"));
const RReturnCustomer = lazy(() => import("../page/report/return_customer/ReportReturnCustomer"));
const RReturnSupplier = lazy(() => import("../page/report/return_supplier/ReportReturnSupplier"));
const RSalesCommission = lazy(() => import("../page/report/commission/ReportSalesCommission"));
const RStockPrice = lazy(() => import("../page/report/stock_price/ReportStockPrice"));
const RDelivery = lazy(() => import("../page/report/delivery/DeliveryReport"));
const RHPP = lazy(() => import("../page/report/hpp/HPPReport"));
const RPaymentSales = lazy(() => import("../page/report/payment/PaymentSalesReport"));
const RPaymentPurch = lazy(() => import("../page/report/payment/PaymentPurchReport"));

const RGroup = lazy(() => import("../page/report/group/GroupReport"));
const RGroupView = lazy(() => import("../page/report/group/view/GroupReportDetail"));
const RGroupItemStockView = lazy(() => import("../page/report/group/view/GroupReportDetailItemStock"));
const RGroupItemInView = lazy(() => import("../page/report/group/view/GroupReportDetailItemIn"));
const RGroupItemOutView = lazy(() => import("../page/report/group/view/GroupReportDetailItemOut"));

export const reportListRoutes = [
    rSellingInvoiceRoute,
    rSellingInvoiceDetailRoute,
    rPurchInvoiceRoute,
    rDORoute, rDODetailRoute,
    rSORoute, rSODetailRoute,
    rReturnCustomerRoute,
    rReturnSupplierRoute,
    rSalesCommissionRoute,
    rStockPriceRoute,
    rDeliveryRoute,
    rGroupRoute,
    rHPPRoute,
    rPaymentSalesRoute,
    rPaymentPurchRoute,
];

export const reportMutationRoutes = [
    rGroupViewItemStockRoute, rGroupViewItemInRoute, rGroupViewItemOutRoute
]


export const reportRoutes = {
    element: <Report />,
    children: [
        { ...rSellingInvoiceRoute, element: <RSellingInvoice /> },
        { ...rSellingInvoiceDetailRoute, element: <RSellingInvoiceDetail /> },
        { ...rPurchInvoiceRoute, element: <RPurchaseInvoice /> },
        { ...rDORoute, element: <RDO /> },
        { ...rDODetailRoute, element: <RDODetail /> },
        { ...rSORoute, element: <RSO /> },
        { ...rSODetailRoute, element: <RSODetail /> },
        { ...rReturnCustomerRoute, element: <RReturnCustomer /> },
        { ...rReturnSupplierRoute, element: <RReturnSupplier /> },
        { ...rSalesCommissionRoute, element: <RSalesCommission /> },
        { ...rStockPriceRoute, element: <RStockPrice /> },
        { ...rDeliveryRoute, element: <RDelivery /> },
        { ...rGroupRoute, element: <RGroup /> },
        {
            element: <RGroupView />,
            children: [
                { ...rGroupViewItemStockRoute, element: <RGroupItemStockView /> },
                { ...rGroupViewItemInRoute, element: <RGroupItemInView /> },
                { ...rGroupViewItemOutRoute, element: <RGroupItemOutView /> },
            ],
        },
        { ...rHPPRoute, element: <RHPP /> },
        { ...rPaymentSalesRoute, element: <RPaymentSales /> },
        { ...rPaymentPurchRoute, element: <RPaymentPurch /> },
    ],
};
